import React, { useContext, useEffect } from 'react';
import './CSS/MyOrders.css';
import { ShopContext } from '../Context/ShopContext';
// --- UI/UX UPGRADE: Import professional icons and skeleton loader ---
import { FiBox } from 'react-icons/fi';
import { Link } from 'react-router-dom';
// import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

// --- UI/UX UPGRADE: A sub-component for a single, redesigned Order Card ---
const OrderCard = ({ order }) => {
    const unrollItems = (items) => {
        if (!Array.isArray(items)) return [];
        return items.flatMap(item => {
            const deliveredCount = item.deliveredCount || 0;
            return Array.from({ length: item.quantity }, (_, index) => ({
                ...item,
                instanceId: `${item._id}-${index}`,
                isInstanceDelivered: index < deliveredCount,
            }));
        });
    };

    return (
        <div className="order-card">
            <div className="order-card-header">
                <div className="order-card-info">
                    <h3>Order #{order.orderId.slice(-6)}</h3>
                    <p>
                        <span>Placed: {new Date(order.createdAt).toLocaleDateString()}</span>
                        <span>Deliver to: {order.deliveryAddress?.name ? (
                            <strong>{order.deliveryAddress.name} - </strong>
                        ) : null}{order.deliveryAddress?.addressLine1 ? (
                            `${order.deliveryAddress.addressLine1}, ${order.deliveryAddress.district}`
                        ) : order.deliveryLocation}</span>
                    </p>
                </div>
                <div className={`order-card-status ${order.orderStatus?.toLowerCase()}`}>
                    {order.orderStatus}
                </div>
            </div>
            <div className="order-card-items">
                {unrollItems(order.items).map((item) => (
                    <div
                        key={item.instanceId}
                        className={`order-card-item ${item.isInstanceDelivered ? 'delivered' : ''}`}
                    >
                        <span>{item.name}</span>
                        <span className="item-status">{item.isInstanceDelivered ? 'Delivered' : 'On the way'}</span>
                    </div>
                ))}
            </div>
            <div className="order-card-footer">
                <span>Total</span>
                <strong>₹{order.totalAmount.toFixed(2)}</strong>
            </div>
        </div>
    );
};

// --- UI/UX UPGRADE: A sub-component for the skeleton loading state ---
const OrderSkeleton = () => (
    <div className="order-card-skeleton">
        <div className="skeleton skeleton-line-long"></div>
        <div className="skeleton skeleton-line-short"></div>
        <hr className="skeleton-divider" />
        <div className="skeleton skeleton-line-medium"></div>
        <div className="skeleton skeleton-line-medium"></div>
    </div>
);

const MyOrders = () => {
    const { orders, ordersLoading, user, fetchOrders } = useContext(ShopContext);

    // This effect ensures orders are fetched when the component mounts or user changes.
    useEffect(() => {
        if (user) {
            fetchOrders(user._id);
        }
    }, [user, fetchOrders]);

    if (!user) {
        return <p className="myorders-message">Please log in to see your orders.</p>;
    }

    // Show a professional skeleton loader while fetching
    if (ordersLoading) {
        return (
            <div className="myorders container">
                <h1>My Orders</h1>
                <div className="myorders-container">
                    <OrderSkeleton />
                    <OrderSkeleton />
                    <OrderSkeleton />
                </div>
            </div>
        );
    }

    // Show an engaging empty state when there are no orders
    if (orders.length === 0) {
        return (
            <div className="myorders-empty">
                <FiBox size={80} className="myorders-empty-icon" />
                <h2>No Orders Yet</h2>
                <p>Your past orders will appear here once you've made a purchase.</p>
                <Link to="/" className="myorders-empty-button">Start Shopping</Link>
            </div>
        );
    }

    return (
        <div className="myorders container">
            <h1>My Orders</h1>
            <div className="myorders-container">
                {orders.map((order) => (
                    <OrderCard key={order._id} order={order} />
                ))}
            </div>
        </div>
    );
};

export default MyOrders;